import React from "react";
import styles from "./Navbar.module.css";
import logo from "../images/logo.base.svg";

const Navbar = ({ handleAuthClick }) => {
  return (
    <nav className={`${styles.navbar} navbar navbar-expand-lg`}>
      <div className="container">
        <a
          className={`${styles.brand} navbar-brand d-flex align-items-center`}
          href="#"
        >
          <img
            src={logo} // Replace with your logo path
            alt=""
            className={styles.logo}
          />
          Buzzcom
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className={`${styles.navLink} nav-link`} href="#">
                Demos
              </a>
            </li>
            <li className="nav-item">
              <a className={`${styles.navLink} nav-link`} href="#">
                About
              </a>
            </li>
            <li className="nav-item">
              <a className={`${styles.navLink} nav-link`} href="#">
                Blog
              </a>
            </li>
            <li className="nav-item">
              <a className={`${styles.navLink} nav-link`} href="#">
                Pages
              </a>
            </li>
            <li className="nav-item">
              <a className={`${styles.navLink} nav-link`} href="#">
                Contact
              </a>
            </li>
          </ul>
          <div className="d-flex align-items-center">
            <div
              className={`${styles.navLink} nav-link me-3`}
              onClick={handleAuthClick}
            >
              Login
            </div>
            <div
              className={`${styles.getStartedBtn} btn px-3 `}
              onClick={handleAuthClick}
            >
              Get Started Free
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
